import { useForm, useWatch } from 'react-hook-form'
import { useDebounce } from '@node-space/hooks'
import { RewardFormValues } from '../types'

const DEFAULT_FORM_VALUES: RewardFormValues = {
  currency: 'USDC',
  amount: 100000,
}

export const useRewardsForm = () => {
  const { control, register, setValue } = useForm<RewardFormValues>({
    defaultValues: DEFAULT_FORM_VALUES,
  })

  const formValues = useWatch({ control })
  const selectedCurrency = formValues.currency
  const amount = formValues.amount

  const debouncedAmount = useDebounce(amount, 500)

  const onAmountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue('amount', Number(e.target.value))
  }

  const onCurrencyChange = (value: string) => {
    setValue('currency', value)
  }

  return {
    formValues,
    register,
    selectedCurrency,
    amount: debouncedAmount,
    onAmountChange,
    onCurrencyChange,
  }
}
